import { MQTTClient } from "@infrastructure/clients/mqtt/clients/base/mqtt.client";
import type { MQTTSubscribeOptions } from "@infrastructure/clients/mqtt/clients/base/mqtt.client";

export class IoTMQTTClient extends MQTTClient {
  wsBaseUrl = "wss://api.phodo.ru/mqtt";

  async connectToMQTT(): Promise<void> {
    await this.connect("/mqtt");
  }

  subscribeToDevice(deviceId: string, options: Omit<MQTTSubscribeOptions, "topic">): () => void {
    return this.subscribe(`devices/${deviceId}/+`, {
      topic: `devices/${deviceId}/+`,
      ...options,
    });
  }

  publishToDevice(deviceId: string, command: string, payload: any): void {
    this.publish(`devices/${deviceId}/commands/${command}`, payload, 1);
  }
}

